"use strict";require("react"),require("react-helmet");var e=require("react/jsx-runtime");exports.default=function(){return e.jsx(e.Fragment,{})};